<template>
  <div type="outlined" class="flex flex-col gap-0.5">
    <div
      class="bg-surface-container rounded-t-large rounded-b-extra-small flex h-13 flex-row items-center pr-1.5 pl-4"
    >
      <h3 class="text-title-medium grow">{{ title }}</h3>
    </div>
    <div
      v-if="questions.length == 0"
      class="rounded-t-extra-small rounded-b-large bg-surface-container flex w-full items-center justify-center p-4"
    >
      <span class="text-body-medium text-on-surface-variant">Nichts ausgewählt</span>
    </div>
    <div class="flex grow flex-col">
      <ul class="flex flex-col gap-0.5">
        <li
          v-for="question in questions"
          :key="question.question.id"
          class="rounded-extra-small last:rounded-b-large bg-surface-container flex flex-col p-4"
        >
          <h4 class="text-body-large">{{ question.question.content }}</h4>
          <PerspectiveValueBarNew
            :values="perspectiveBarEntries(question)"
            :scale="scale"
            :all-perspectives="topicPerspectives"
          />
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
  import PerspectiveValueBarNew from '@/core/components/analytics/question-list/PerspectiveValueBarNew.vue'
  import type { Perspective } from '@/core/models/perspective'
  import { toValueBarPerspectives } from '@/core/models/perspective-analysis'
  import type { QuestionAnalysis } from '@/core/models/surveys-analytics'
  interface Props {
    title: string
    questions: ReadonlyArray<QuestionAnalysis>
    topicPerspectives: ReadonlyArray<Perspective>
    scale: ReadonlyArray<{ value: number; label: string }>
  }
  const props = defineProps<Props>()

  const perspectiveBarEntries = (question: QuestionAnalysis) =>
    toValueBarPerspectives(question.perspectives, props.topicPerspectives)
</script>
